import { render, staticRenderFns } from "./NAppMessageInputBar.vue?vue&type=template&id=09de0cfe&scoped=true&"
import script from "./NAppMessageInputBar.vue?vue&type=script&lang=js&"
export * from "./NAppMessageInputBar.vue?vue&type=script&lang=js&"
import style0 from "./NAppMessageInputBar.vue?vue&type=style&index=0&id=09de0cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de0cfe",
  null
  
)

export default component.exports